import React, { useEffect, useState } from "react";
import {
    Link,
    useNavigate,
    useParams,
} from "react-router-dom";

import toast from "react-hot-toast";
import PageHeader1 from "../../components/common/PageHeader1";
import axios from "axios";

function WalletTagesAdd() {
    const { id } = useParams();

    const navigate = useNavigate();

    const [tagName, setTagName] = useState("");
    const [loading, setLoading] = useState(false);

    const BASE_URL = process.env.REACT_APP_BASEURL;

    const token = localStorage.getItem(
        "astroVani-admin-token"
    );

    const isEditMode = Boolean(id);

    useEffect(() => {
        if (!isEditMode) return;

        const fetchTag = async () => {
            setLoading(true);

            try {
                const response = await axios.get(
                    `${BASE_URL}/admin/rechargePackTag/${id}`,
                    {
                        headers: {
                            Authorization: token,
                        },
                    }
                );

                const tag = response.data?.data;

                setTagName(
                    tag?.rechargePackTag ?? ""
                );
            } catch (error) {
                toast.error(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Failed to load Wallet Tag details."
                );
            } finally {
                setLoading(false);
            }
        };

        fetchTag();
    }, [
        BASE_URL,
        id,
        isEditMode,
        token,
    ]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!tagName.trim()) {
            toast.error("Tag name is required.");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                rechargePackTag: tagName.trim(),
            };

            if (isEditMode) {
                await axios.patch(
                    `${BASE_URL}/admin/rechargePackTag/${id}`,
                    payload,
                    {
                        headers: {
                            Authorization: token,
                        },
                    }
                );

                toast.success(
                    "Wallet Tag updated successfully!"
                );
            } else {
                await axios.post(
                    `${BASE_URL}/admin/rechargePackTag`,
                    payload,
                    {
                        headers: {
                            Authorization: token,
                        },
                    }
                );

                toast.success(
                    "Wallet Tag created successfully!"
                );
            }

            navigate("/consultation-voucher-tag");
        } catch (error) {
            toast.error(
                error?.response?.data?.message ||
                error?.message ||
                "Failed to save Wallet Tag."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="body d-flex py-lg-3 py-md-2">
            <div className="container-xxl">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <PageHeader1
                        pagetitle={
                            isEditMode
                                ? "Edit Wallet Tag"
                                : "Add Wallet Tag"
                        }
                    />

                    <Link
                        to="/consultation-voucher-tag"
                        className="btn btn-secondary"
                        style={{ height: "38px" }}
                    >
                        Back to List
                    </Link>
                </div>

                <div className="row clearfix g-3 mt-1">
                    <div className="col-lg-8">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Tag Name
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={tagName}
                                            onChange={(e) =>
                                                setTagName(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Enter wallet tag name"
                                        />
                                    </div>

                                    <div className="d-flex gap-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading
                                                ? "Saving..."
                                                : isEditMode
                                                    ? "Update"
                                                    : "Save"}
                                        </button>

                                        <Link
                                            to="/consultation-voucher-tag"
                                            className="btn btn-outline-secondary"
                                        >
                                            Cancel
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WalletTagesAdd;